import { render, staticRenderFns } from "./XwTable.vue?vue&type=template&id=644ffd22&scoped=true"
import script from "./XwTable.vue?vue&type=script&lang=js"
export * from "./XwTable.vue?vue&type=script&lang=js"
import style0 from "./XwTable.vue?vue&type=style&index=0&id=644ffd22&prod&lang=scss"
import style1 from "./XwTable.vue?vue&type=style&index=1&id=644ffd22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644ffd22",
  null
  
)

export default component.exports